import React, { FC } from 'react';

import { Select } from '@rbilabs/components-library/build/components/select';
import { useIntl } from 'react-intl';

import { ISOs } from 'utils/form/constants';

import { messageIdMap } from './generated/country-info';
import { ICountrySelectBaseProps } from './types';

const CountrySelectBase: FC<ICountrySelectBaseProps> = ({ countries, ...otherProps }) => {
  const { formatMessage } = useIntl();

  let options: { label: string; value: ISOs | '' }[] = countries.map(countryCode => ({
    label: formatMessage({ id: messageIdMap[countryCode] }),
    value: countryCode,
  }));

  if (otherProps.value === '') {
    options = [{ value: '', label: formatMessage({ id: 'selectACountry' }) }, ...options];
  }

  return <Select options={options} required {...otherProps} />;
};

export default CountrySelectBase;
